'use strict';
import { observable, action } from 'mobx';
import { fetch, buildUrl } from '@/lib/fetchAPI';

class DeviceInfoAppStore {
  @observable deviceAppDetail = [];
  @action
  loadAppDetail(deviceId) {
    fetch(
      `/api/app/list${buildUrl({ device_id: deviceId })}`,
      { method: 'GET' },
      json => {
        this.deviceAppDetail = [...json] || [];
      }
    );
  }
}
export default new DeviceInfoAppStore();



// WEBPACK FOOTER //
// ./src/store/DeviceInfo/DeviceApp.js